import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Add = ({ show, onClose, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [reason_name, setname] = useState('');
    const [errors, setErrors] = useState({});
    const [data_name, setData] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/followupreason`)
            .then(response => {
                setData(response.data.data.data.map(mode => mode.name.toLowerCase()));
            })
            .catch(error => {
            console.log('There was an error fetching the data!', error);
            });
    }, []);
    
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;

        if (!reason_name.trim()) {
            newErrors.name = "This Field is Required.";
            // return newErrors;
        } else if (!regex.test(reason_name)) {
            newErrors.name = "Not a Valid Name";
            // return newErrors;
        } else if (data_name.includes(reason_name.trim().toLowerCase())) {
            newErrors.name = "This Name Alredy Exists";
            // return newErrors;
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { name: reason_name };
        axios.post(`${baseURL}/followupreason`, postData)
            .then(response => {
                onClose();
                refresh();
                // window.location.reload();
                toast.success("Followup Reason Created Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Followup Reason Creation Failed");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Followup Reason</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Followup Reason<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Followup Reason" 
                                maxLength={100}
                                value={reason_name} 
                                onChange={(e) => setname(formatName(e.target.value))} 
                            />
                            {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                        </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary" >Create Followup Reason<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default Add;
